<template>
  <div>
    <a-space>
      <vxe-input v-model="query['order.no']" placeholder="placeholder.receiptOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['command.id']" placeholder="business.label.commandId" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['storageRoom.name']" placeholder="business.label.storageRoom" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['zone.name']" placeholder="business.label.zone" @clear="refresh" @keydown.native.enter="refresh"/>
      <a-date-picker v-model="query.commandDateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('business.label.startTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.commandDateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('business.label.endTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
    </a-space>
    <a-space>
      <vxe-input v-model="query['item.no']" placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['item.name']" placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['item.mnemonicCode']" placeholder="business.label.mnemonicCode" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['lot.no']" placeholder="business.label.lot" @clear="refresh" @keydown.native.enter="refresh"/>
    </a-space>
    <storage-room-modal ref="storageRoomModal" @change="setStorageRoom"/>
    <zone-modal ref="zoneModal" @change="setZone"/>
    <shelf-task ref="shelfTask" :scroll-y="scrollY"/>
  </div>
</template>

<script>
import moment from 'moment'
import PageUtil from '@/components/Pagination/PageUtil.vue'
import { findAll } from '@/api/Api'
import ShelfTask from '@/views/inbound/shelf/ShelfTask.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'ShelfByArgs',
    components: {ZoneModal, StorageRoomModal, ShelfTask, PageUtil},
    data() {
      return {
        selectedRowKeys: [],
        selectedRows: [],
        data: [],
        owners: [],
        orderStatusData: [],
        contentSize: 0,
        page: 1,
        size: 5,
        loading: false,
        query: {
          'order.no': '',
          'command.id': '',
          commandDateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.mnemonicCode': '',
          'lot.no': '',
          'storageRoom.name': '',
          'zone.name': ''
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.735),// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    mounted() {
      findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
        if (res.success) {
          this.owners = res.result
        }
      })
    },
    methods: {
      moment,
      disabledStartDate(startValue) {
        const endValue = this.query.commandDateFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.query.commandDateFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      setStorageRoom(storageRoomData) {
        if (storageRoomData.length !== 0) {
          let sr = storageRoomData[0]
          this.query['storageRoom.name'] = sr.name
          this.query['zone.name'] = null
        } else {
          this.query['storageRoom.name'] = null
          this.query['zone.name'] = null
        }
      },
      setZone(zoneData) {
        if (zoneData.length !== 0) {
          let zone = zoneData[0]
          this.query['zone.name'] = zone.name
        } else {
          this.query['zone.name'] = null
        }
      },
      refresh() {
        this.$refs.shelfTask.search(this.query)
      },
      reset() {
        this.query = {
          'order.no': '',
          'command.id': '',
          commandDateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.mnemonicCode': '',
          'lot.no': '',
          'storageRoom.name': '',
          'zone.name': ''
        }
        this.$refs.shelfTask.reset()
      },
      confirm() {
        this.$refs.shelfTask.putaway()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 200px;
  }
</style>